import { useEffect, useState, useRef, useCallback, use } from 'react'
import { useTranslation } from 'src/utils/i18n'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Image from 'next/image'
import dayjs from 'dayjs'
import Link from 'next/link'
import { Modal, Table, Button } from 'antd'
import { motion } from 'framer-motion'
import { fetchResetTime, selectDeviceRequestKey, setCurrentTab, toggleNavVisibility } from 'src/store/apps/Common'
import { userDeviceCurrent, sendLikeType, getUserAccountOrder, getAllUserDevice } from 'src/@api/login'

// components
import { getGcloudAll, extendSubscriptionTime, getMenuFavorite, postMenuFavorite } from '/src/@api/dashboard'
import { useRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import FirstBinding from 'src/components/FirstBinding'
import { messageInfo } from 'src/components/Message'
import ExpirationReminder from 'src/components/ExpirationReminder'
import DisconnectDetection from 'src/components/DisconnectDetection'
import { matchCurrentDevice, reloadAfterRenewSuccess } from 'src/utils/refreshSubscriptionExpire'
import { isBasicOrderLevel } from 'src/utils/orderLevel'
import ContentLoading from 'src/components/ContentLoading'
import { fetchRenewProductIdForOrder } from 'src/utils/renewalPlans'
import { resolveDeviceOrder, pickLatestExpireOrder, resolveCardSubscription } from 'src/utils/currentOrder'
import AndroidLogin from 'src/@core/components/android/login'

const Dashboard1 = () => {
  const dispatch = useDispatch()
  const router = useRouter()
  const { t } = useTranslation('common')

  // 异步 Dashboard 拉数归属键，切换设备后旧请求结果会被忽略
  const deviceRequestKey = useSelector(selectDeviceRequestKey)
  const deviceRequestKeyRef = useRef(deviceRequestKey)
  deviceRequestKeyRef.current = deviceRequestKey

  let Basic = window.localStorage.getItem('Basic')
  Basic = Basic == null || Basic == 0 ? true : false

  if (window.localStorage.getItem('addDevice') == '1') {
    Basic = true
  }

  // 基础数据模块
  const [typeModule, setTypeModule] = useState([
    {
      id: 1,
      name: 'Text Messages',
      img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_SMS,
      num: 0,
      href: '/android/text-messages',
      eventName: 'Click_Textmessages'
    },
    {
      id: 2,
      name: 'WhatsApp',
      img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_WHATSAPP,
      num: 0,
      href: '/android/whatsapp',
      eventName: 'Click_WhatsApp'
    },
    {
      id: 3,
      name: 'Locations',
      img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_LOCATIONS,
      num: 0,
      href: '/android/locations',
      eventName: 'Click_GPSlocation'
    },
    {
      id: 4,
      name: 'Photo',
      img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_PHOTOS,
      num: 0,
      href: '/android/photos',
      eventName: 'Click_Photo'
    },
    {
      id: 5,
      name: 'Video',
      img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_VIDEO,
      num: 0,
      href: '/android/videos',
      eventName: 'Click_Video'
    },
    {
      id: 6,
      name: 'Email',
      img: '/images/dashboard/new-android/gmail.svg',
      num: 0,
      href: '/android/email',
      eventName: 'Click_Email'
    },
    {
      id: 7,
      name: 'Contact',
      img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_CONTACTS,
      num: 0,
      href: '/android/contacts',
      eventName: 'Click_Contact'
    },
    {
      id: 8,
      name: 'Browser history',
      img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_HISTORY,
      num: 0,
      href: '/android/browser-history',
      eventName: 'Click_Browserhistory'
    },
    {
      id: 9,
      name: 'Browser Bookmark',
      img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_BOOKMARK,
      num: 0,
      href: '/android/browser-bookmark',
      eventName: 'Click_Browserbookmark'
    },
    {
      id: 10,
      name: 'Wi-Fi Networks',
      img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_WIFI,
      num: 0,
      href: '/android/wifi-networks',
      eventName: 'Click_Wifinetwork'
    },
    {
      id: 11,
      name: 'Keep',
      img: process.env.NEXT_PUBLIC_DASHBOARD_ICON_ANDROID_KEEP,
      num: 0,
      href: '/android/keep',
      eventName: 'Click_Keep'
    }
  ])

  // 克隆列表
  const [cloneList, setCloneList] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  // 数据量最多的常用app列表
  const [frequentlyArr, setFrequentlyArr] = useState([])

  //初始化列表
  useEffect(() => {
    if (window.innerWidth < 780 && typeModule && typeModule.length > 0) {
      // 过滤出指定 name 的 icon 并按 num 值降序排序
      let selectedIcons = typeModule.filter(icon => {
        return (
          [
            'Text Messages',
            'WhatsApp',
            'Email',
            'Locations',
            'Photo',
            'Video',
            'Browser history',
            'Browser Bookmark',
            'Wi-Fi Networks'
          ].includes(icon.name) && icon.num > 0
        )
      })

      if (selectedIcons.length === 0) {
        return
      }

      // 过滤出不在 selectedIcons 中的其他 icon 并按 num 值降序排序
      let _selectedIcons = typeModule
        .filter(
          icon =>
            !(
              [
                'Text Messages',
                'WhatsApp',
                'Email',
                'Locations',
                'Photo',
                'Video',
                'Browser history',
                'Browser Bookmark',
                'Wi-Fi Networks'
              ].includes(icon.name) && icon.num > 0
            )
        )
        .sort((a, b) => b.num - a.num)
      setCloneList([...selectedIcons, ..._selectedIcons].slice(0, 9))

      localStorage.setItem(
        'frequentlyArr',
        JSON.stringify([...selectedIcons, ..._selectedIcons].sort((a, b) => b.num - a.num).slice(0, 3))
      )

      setFrequentlyArr([...selectedIcons, ..._selectedIcons].sort((a, b) => b.num - a.num).slice(0, 3))
    } else {
      setCloneList(typeModule)

      localStorage.setItem('frequentlyArr', JSON.stringify([...typeModule].sort((a, b) => b.num - a.num).slice(0, 3)))

      setFrequentlyArr([...typeModule].sort((a, b) => b.num - a.num).slice(0, 3))
    }
  }, [typeModule])

  const getData = async requestKey => {
    setIsLoading(true)
    let list = typeModule.map(item => ({ ...item }))

    let deviceUser =
      JSON.parse(localStorage.getItem('DeviceUser')) != null
        ? JSON.parse(localStorage.getItem('DeviceUser')).username
        : ''

    if (deviceUser == '') {
      setIsLoading(false)

      return
    }

    try {
      let all = await getGcloudAll({
        username: deviceUser,
        params: {
          category: 'USER_SUMMARY',
          offset: 0,
          limit: 4
        }
      })

      if (deviceRequestKeyRef.current !== requestKey) return

      const summary = all?.data?.summary
      if (!summary || typeof summary !== 'object') {
        setIsLoading(false)

        return
      }

      if (Array.isArray(summary.advance)) setTargetDeviceList(summary.advance)

      if (all.code === 1002) {
        setIsLoading(false)

        return
      }

      let deviceUdid =
        JSON.parse(localStorage.getItem('currentDevice')) != null
          ? JSON.parse(localStorage.getItem('currentDevice'))['id']
          : ''

      try {
        list[1].num = summary.whatsapp
        list[2].num = summary.location
        list[3].num = summary.photo
        list[4].num = summary.video
        list[5].num = summary.gmail
        list[6].num = summary.contact
        list[7].num = summary.chrome_history
        list[8].num = summary.chrome_bookmark
        list[9].num = summary.wifi
        list[10].num = summary.keep

        // 获取短信
        if (Array.isArray(summary.advance)) {
          let find = summary.advance.find(row => {
            if (row.device != null && row.device.id == deviceUdid) {
              return row
            }
          })

          list[0].num = find?.sms
        }
      } catch (error) {
        console.log(error)
      }

      setTypeModule(list)

      localStorage.setItem('userSummary', JSON.stringify(list))

      if (window.localStorage.getItem('addDevice') == '1') {
        setTimeout(() => {
          localStorage.removeItem('addDevice')
        }, 1000 * 3)
      }
    } finally {
      if (deviceRequestKeyRef.current === requestKey) {
        setIsLoading(false)
      }
    }
  }

  useEffect(() => {
    let check =
      JSON.parse(localStorage.getItem('DeviceUser')) != null
        ? JSON.parse(localStorage.getItem('DeviceUser')).username
        : ''

    if (check == '') {
      localStorage.setItem('Basic', 0)
    }

    dispatch(fetchResetTime())
    const timer = setTimeout(() => {
      getData(deviceRequestKey)
    }, 1500)

    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceRequestKey])

  const [tips, setTips] = useState(false)
  const [orderData, setOrderData] = useState([])
  const [orderListData, setOrderListData] = useState({})

  // 当前设备的平台类型。必须以【设备接口】user-device 为准：
  // 订单接口 user-account-order 的 platform_type 是「购买的产品」，
  // 不等于当前设备类型（安卓设备的订单也可能是 iOS 产品，反之亦然）。
  const [currentDevicePlatform, setCurrentDevicePlatform] = useState('')
  const [currentIndex, setCurrentIndex] = useState(0)
  const [orderIndex, setOrderIndex] = useState(0)
  const [showDeviceList, setShowDeviceList] = useState(false)
  const [showOrderList, setShowOrderList] = useState(false)
  const [targetDeviceList, setTargetDeviceList] = useState([])

  const orderListRef = useRef(null)
  const toggleButtonRef = useRef(null) // 绑定按钮引用

  // 点击按钮显示/隐藏弹窗
  const handleClickOutside = useCallback(
    event => {
      // 检查点击的地方是否在按钮或弹窗内
      if (
        showOrderList &&
        orderListRef.current &&
        !orderListRef.current.contains(event.target) &&
        toggleButtonRef.current &&
        !toggleButtonRef.current.contains(event.target)
      ) {
        setShowOrderList(false)
      }
    },
    [showOrderList]
  )

  const changeOrder = (item, index) => {
    setOrderListData(item)
    setOrderIndex(index)
    setShowOrderList(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [handleClickOutside])

  const FirstOrderData = async requestKey => {
    // 设备接口失败不应连累订单卡片，故单独兜底为 null
    const [allDeviceUser, deviceRes] = await Promise.all([
      getUserAccountOrder({ page: 1, pageSize: 9999 }),
      getAllUserDevice({}).catch(() => null)
    ])

    if (deviceRequestKeyRef.current !== requestKey) return

    // 当前设备类型取【设备接口】user-device，不能用订单接口的 platform_type。
    let storedDeviceUser = {}
    try {
      storedDeviceUser = JSON.parse(localStorage.getItem('DeviceUser') || '{}') || {}
    } catch {
      storedDeviceUser = {}
    }
    const matchedDevice = matchCurrentDevice(deviceRes?.data, storedDeviceUser)
    setCurrentDevicePlatform(matchedDevice?.platform_type || '')

    let all = allDeviceUser.data

    // 遍历数组并设置 `name` 属性
    all?.forEach((item, index) => {
      item.name = `Acount${String(index + 1).padStart(2, '0')}`
    })
    setOrderData(all || [])
    if (all.length > 0) {
      let DeviceUser = null
      try {
        DeviceUser = JSON.parse(localStorage.getItem('DeviceUser') || 'null')
      } catch (e) {
        DeviceUser = null
      }

      // 当前设备的关联订单：优先用设备接口的 order_id 直接命中订单主键；
      // 没有 order_id 时按 device_id 找，命中多张则取过期时间最晚的那张（最新的关联单）。
      let lastOrder = DeviceUser
        ? resolveDeviceOrder({ orders: all, deviceUser: DeviceUser, device: matchedDevice })
        : null

      // 没有设备上下文（未选中任何设备）时才退回「全局过期最晚的一张」
      if (!lastOrder && !DeviceUser) {
        lastOrder = pickLatestExpireOrder(all)
      }

      // 卡片展示以【设备接口】为准：user-device 现在直接返回
      // order_id / product_name / order_level / expire_time，就是这台设备当前的订阅状态；
      // 订单只用于补设备接口没有的字段（如 merchant_no → 注册码行）。
      setOrderListData(resolveCardSubscription({ order: lastOrder, device: matchedDevice }))
    }
  }

  let { data: userData } = JSON.parse(localStorage.getItem('userData'))

  useEffect(() => {
    FirstOrderData(deviceRequestKey)
  }, [deviceRequestKey])

  // 延长续订
  const [extendSubscriptionModal, setExtendSubscriptionModal] = useState(false)

  const extendSubscription = async () => {
    const renewId = await fetchRenewProductIdForOrder(orderListData)
    if (!renewId) {
      window.dispatchEvent(new Event('renewalFailed'))
      messageInfo({
        content: t('Payment failed'),
        duration: 6
      })
      setExtendSubscriptionModal(false)

      return
    }

    let result = await extendSubscriptionTime({
      merchant_no: orderListData.merchant_no,
      renewId,
      order_type: 274
    })
    if (Number(result.code) === 0) {
      messageInfo({
        content: `${result.msg}`,
        duration: 1.5
      })
      setExtendSubscriptionModal(false)
      // 与 iOS dashboard / ExpiredPurchaseGuide 一致：整页刷新，避免过期 banner/遮罩残留
      reloadAfterRenewSuccess()

      return
    }

    window.dispatchEvent(new Event('renewalFailed'))

    messageInfo({
      content: `${result.msg}`,
      duration: 6
    })

    setExtendSubscriptionModal(false)
  }

  const openNav = () => {
    dispatch(toggleNavVisibility(true))
  }

  useEffect(() => {
    dispatch(setCurrentTab(t('Dashboard')))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  // 埋点上报
  useEffect(() => {
  }, [])

  const [favoriteArr, setFavoriteArr] = useState([])
  const menuCacheRef = useRef({}) // { [device_id]: menuList }

  useEffect(() => {
    const requestKey = deviceRequestKey
    const init = async (forceRefresh = false) => {
      if (!cloneList) return
      const deviceUser = localStorage.getItem('DeviceUser')
      const device_id = deviceUser ? JSON.parse(deviceUser).device_id : ''
      if (!device_id) return
      const cloneListMap = new Map(cloneList.map(item => [(item.href || item.url).toLowerCase(), item]))

      let menuList = menuCacheRef.current[device_id]
      if (!menuList || forceRefresh) {
        menuList = await getMenuFavorite(device_id)
        if (deviceRequestKeyRef.current !== requestKey) return
        menuCacheRef.current[device_id] = menuList
      }
      const hasInit = localStorage.getItem(`menuFavoriteInit-${device_id}`)

      if (!hasInit && (!menuList?.data || menuList.data.length === 0)) {
        localStorage.setItem(`menuFavoriteInit-${device_id}`, 'true')
        await Promise.all([
          postMenuFavorite({ device_id: device_id, name: 'Text message', url: '/android/text-messages', status: true }),
          postMenuFavorite({ device_id: device_id, name: 'Photo', url: '/android/photos', status: true }),
          postMenuFavorite({ device_id: device_id, name: 'Email', url: '/android/email', status: true }),
          postMenuFavorite({ device_id: device_id, name: 'WhatsApp', url: '/android/whatsapp', status: true })
        ])
        if (deviceRequestKeyRef.current !== requestKey) return

        let retry = 3
        while (retry > 0) {
          menuList = await getMenuFavorite(device_id)
          if (deviceRequestKeyRef.current !== requestKey) return
          if (menuList?.data && menuList.data.length > 0) break
          await new Promise(resolve => setTimeout(resolve, 100))
          retry--
        }
        menuCacheRef.current[device_id] = menuList
      }

      const result = (menuList?.data || []).map(item => cloneListMap.get(item.url.toLowerCase())).filter(Boolean)
      if (deviceRequestKeyRef.current !== requestKey) return
      setFavoriteArr(result)
    }

    init()
    const handler = () => init(true) // 强制刷新
    window.addEventListener('menuUpdated', handler)

    return () => {
      window.removeEventListener('menuUpdated', handler)
    }
  }, [cloneList, deviceRequestKey])

  // 卡片上判断「是不是 iOS / 安卓」一律用设备类型（设备接口），
  // 订单类型只作为设备类型取不到时的兜底，避免改变原有表现。
  const cardPlatformType = currentDevicePlatform || orderListData?.platform_type || ''

  return (
    <div style={{ userSelect: 'none' }}>
      {/* <FirstBinding /> */}
      <ExpirationReminder orders={orderData} />
      <DisconnectDetection />
      <div className='relative min-h-[calc(var(--vh2)*100-90px)]'>
        {isLoading ? (
          <div className='absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]'>
            <ContentLoading />
          </div>
        ) : null}
      <Grid container spacing={6}>
        <Grid item xs={12} md={12} lg={12}>
          {/* <Card style={{ width: '100%', marginBottom: '20px' }} sx={{
            '@media (min-width: 1200px)': {
              display: 'none'
            }
          }}>
            <div className='w-full flex justify-between items-center mb-[10px] px-[18px] pt-4'>
              <h2 className='text-[18px] text-[#222] font-[600] Bxls:hidden'>{t('Frequently used')}</h2>
            </div>
            <CardContent style={{ display: 'flex', flexWrap: 'wrap', paddingBottom: '0px' }}>
              {frequentlyArr.map(row => (
                <Grid
                  key={row.id}
                  item
                  xs={4}
                  md={3}
                  lg={2}
                  className='sm:hidden'
                  style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '10px'
                  }}
                >
                  <Link className='flex flex-col items-center justify-center' href={row.href}>
                    <div className='w-[50px] h-[50px] relative'>
                      <Image
                        src={row.img}
                        alt='img'
                        width={50}
                        height={50}
                        className='mx-auto p-2 rounded-[14px] bg-[#F0F1F5] relative'
                      />
                      <span className='absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center'>
                        {row.num}
                      </span>
                    </div>

                    <span
                      className='text-[12px] Blds:text-[14px] text-[#2E2E2E] mt-[6px] h-[48px] w-full text-center'
                      style={{ textAlign: 'center' }}
                    >
                      {t(row.name)}
                    </span>
                  </Link>
                </Grid>
              ))}
            </CardContent>
          </Card> */}

          {/* 收藏菜单列表 */}
          <Card style={{ width: '100%', marginBottom: '20px' }} className={`${favoriteArr.length === 0 && 'hidden'}`}>
            <div className='w-full flex justify-between items-center mb-[10px] px-[18px] pt-4'>
              <h2 className='text-[18px] text-[#222] font-[600]'>{t('Favorites')}</h2>
            </div>

            <CardContent style={{ display: 'flex', flexWrap: 'wrap' }}>
              {favoriteArr.map(row => (
                <Grid
                  key={row.id}
                  item
                  xs={4}
                  md={3}
                  lg={2}
                  style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '10px'
                  }}
                >
                  <Link
                    className='flex flex-col items-center justify-center'
                    href={row.href}
                    onClick={() => {
                    }}
                  >
                    <div className='w-[50px] h-[50px] relative'>
                      <Image
                        src={row.img}
                        alt='img'
                        width={50}
                        height={50}
                        className='mx-auto p-2 rounded-[14px] bg-[#F0F1F5] relative'
                      />
                      <span className='absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center'>
                        {row.num}
                      </span>
                    </div>

                    <span
                      className='text-[12px] Blds:text-[14px] text-[#2E2E2E] mt-[6px] h-[48px] w-full text-center'
                      style={{ textAlign: 'center' }}
                    >
                      {t(row.name)}
                    </span>
                  </Link>
                </Grid>
              ))}
            </CardContent>
          </Card>

          <Card style={{ width: '100%' }}>
            <div className='w-full flex justify-between items-center mb-[10px] px-[18px] pt-4'>
              <h2 className='text-[18px] text-[#222] font-[600] Bxls:hidden'>{t('Hot features')}</h2>
              <h2 className='text-[18px] text-[#222] font-[600] hidden Bxls:block'>{t('Features')}</h2>
              <div
                className=' border-0 px-[10px] h-[30px] rounded-[22.5px] hover:bg-[#454CFF] text-[#454CFF] hover:text-[#FFF] text-[12px] Bxls:hidden flex items-center font-[600]'
                onClick={openNav}
              >
                {t('SEE ALL')}
              </div>
            </div>

            <CardContent style={{ display: 'flex', flexWrap: 'wrap' }}>
              {cloneList.map(row => (
                <Grid
                  key={row.id}
                  item
                  xs={4}
                  md={3}
                  lg={2}
                  style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '10px'
                  }}
                >
                  <Link
                    className='flex flex-col items-center justify-center'
                    href={row.href}
                    onClick={() => {
                    }}
                  >
                    <div className='w-[50px] h-[50px] relative'>
                      <Image
                        src={row.img}
                        alt='img'
                        width={50}
                        height={50}
                        className='mx-auto p-2 rounded-[14px] bg-[#F0F1F5] relative'
                      />
                      <span className='absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center'>
                        {row.num}
                      </span>
                    </div>

                    <span
                      className='text-[12px] Blds:text-[14px] text-[#2E2E2E] mt-[6px] h-[48px] w-full text-center'
                      style={{ textAlign: 'center' }}
                    >
                      {t(row.name)}
                    </span>
                  </Link>
                </Grid>
              ))}
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <div className='grid grid-cols-3 Hsm:grid-cols-2 Hsm:Dsm:grid-cols-1 w-full gap-[20px] mt-[20px]'>
        <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[30px]'>
          <div className='flex justify-between items-center relative'>
            <h2 className='text-[18px] text-[#222] font-[600]'>{t('Account')}</h2>
            {/* <div
              className='hover:cursor-pointer'
              ref={toggleButtonRef} // 绑定按钮引用
              onClick={event => {
                event.stopPropagation() // 阻止事件冒泡
                setShowOrderList(prev => !prev) // 确保状态切换
              }}
            >
              <Image
                className='w-[24px] h-[24px]'
                src='/images/change-password/drop-down.svg'
                width={24}
                height={24}
                alt='drop down'
              ></Image>
            </div> */}
            {showOrderList && (
              <div
                ref={orderListRef}
                className='bg-[#FFF] w-full absolute left-0 top-[40px] z-10 rounded-[8px] p-[8px] drop-shadow-[0_4px_8px_rgba(0,0,0,0.13)] overflow-auto'
              >
                {orderData.map((row, index) => (
                  <div
                    key={index}
                    onClick={() => changeOrder(row, index)}
                    className={`hover:bg-[#F4F5F6] hover:cursor-pointer px-[15px] py-[10px] ${
                      orderIndex === index ? 'bg-[#F4F5F6]' : ''
                    }`}
                  >
                    {row.name}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className='w-full h-[1px] bg-[#E5E5E5] mt-[20px] mb-[24px]'></div>
          <div className='w-full h-auto flex flex-col justify-between text-[14px]'>
            <div className='w-full flex justify-between items-center h-[36px]'>
              <div className='text-[#334062]'>{t('Product')}:</div>
              <div className='text-[#9198AD]'>{cardPlatformType}</div>
            </div>
            <div className='w-full flex justify-between items-center h-[36px]'>
              <div className='text-[#334062]'>{t('Subscription Plan')}:</div>
              <div className='text-[#9198AD]'>
                {cardPlatformType === 'iOS-Cloud' &&
                  (isBasicOrderLevel(orderListData?.order_level) ? `${t('Basic')} - ` : 'Extreme - ')}
                {orderListData?.product_name}
              </div>
            </div>
            <div className='w-full flex justify-between items-center h-[36px]'>
              <div className='text-[#334062]'>{t('Expiry Date')}:</div>
              <div className='text-[#9198AD]'>{dayjs(orderListData?.expire_time).format('YYYY-MM-DD')}</div>
            </div>
            <div
              className={`w-full flex justify-between items-center h-[36px] ${
                cardPlatformType.includes('Android') && new Date(orderListData?.expire_time) > new Date()
                  ? 'block'
                  : 'hidden'
              }`}
            >
              <div className='text-[#334062]'>{t('Registration Code')}:</div>
              <div className='text-[#9198AD]'>{orderListData?.merchant_no?.slice(-8)}</div>
            </div>
          </div>
          <button
            className='text-[#454CFF] w-full h-[45px] border border-[#454CFF] rounded-[22.5px] mt-[36px] hover:bg-[#454CFF] hover:text-[#FFF]'
            onClick={() => setExtendSubscriptionModal(true)}
          >
            {t('Extend subscription')}
          </button>
        </div>

        {/* <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[24px]'>
          <h2 className='text-[18px] text-[#222] font-[600] mb-[20px]'>{t('Target Device Info')}</h2>
          <div
            className='w-full h-[54px] bg-[#F4F5F6] hover:cursor-pointer rounded-[8px] pl-[8px] pr-[14px] relative flex items-center text-[#334062] text-[16px]'
            onClick={() => setShowDeviceList(val => !val)}
          >
            <div className='ml-[10px]'>
              {targetDeviceList.length !== 0 ? targetDeviceList[currentIndex].device.name : ''}
            </div>
            <div className='h-[54px] flex items-center absolute top-0 right-[12px] cursor-pointer'>
              <motion.div initial={{ rotate: 0 }} animate={{ rotate: showDeviceList ? 180 : 0 }}>
                <Image
                  className='w-[15px] h-[15px]'
                  src='/images/change-password/drop-down.svg'
                  width={15}
                  height={15}
                  alt='drop down'
                ></Image>
              </motion.div>
            </div>
            {showDeviceList && (
              <div className='bg-[#FFF] w-full absolute hover:cursor-pointer left-0 top-[57px] z-10 rounded-[8px] p-[8px] pb-[0] drop-shadow-[0_4px_8px_rgba(0,0,0,0.13)]'>
                {targetDeviceList.map((item, index) => (
                  <div
                    key={index}
                    className={`${
                      currentIndex === index ? 'bg-[#F4F5F6]' : ''
                    } w-full h-[54px] rounded-[8px] pl-[8px] pr-[14px] flex justify-between items-center text-[#334062] text-[16px] mb-[8px]`}
                    onClick={e => {
                      e.stopPropagation()
                      setCurrentIndex(index)
                      setShowDeviceList(false)
                    }}
                  >
                    <div className='flex items-center'>
                      <div className='ml-[10px]'>{item?.device?.name}</div>
                    </div>
                    <div
                      className={`${
                        currentIndex === index ? 'bg-[#2A99FF]' : 'bg-[rgb(224,224,224)]'
                      } w-[8px] h-[8px] rounded-[50%]`}
                    ></div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className='w-full h-[108px] mt-[24px] flex flex-col justify-between'>
            <div className='w-full flex justify-between items-center text-[14px]'>
              <div className='text-[#334062]'>IMEI:</div>
              <div className='text-[#9198AD]'>{targetDeviceList[currentIndex]?.serial_number}</div>
            </div>
            <div className='w-full flex justify-between items-center text-[14px]'>
              <div className='text-[#334062]'>Version:</div>
              <div className='text-[#9198AD]'>{targetDeviceList[currentIndex]?.version}</div>
            </div>
            <div className='w-full flex justify-between items-center text-[14px]'>
              <div className='text-[#334062]'>Model:</div>
              <div className='text-[#9198AD]'>{targetDeviceList[currentIndex]?.device?.model}</div>
            </div>
          </div>
        </div> */}

      </div>
      </div>
      {/* <Grid container spacing={6} style={{ marginTop: '10px' }}>
        <Grid item xs={12} md={6} lg={4}>
          <Messages data={useMessages} />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Contacts data={useContact} />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <Photos data={usePhotos} />
        </Grid>
      </Grid> */}

      {Basic ? <AndroidLogin /> : null}

      <Modal open={tips} onCancel={() => setTips(false)} footer={[]} zIndex={1200}>
        <p>
          {t(
            'Currently you have only purchased the Android monitoring package If you want to monitor an iPhone please click the button'
          )}
        </p>
        <div style={{ textAlign: 'center', marginTop: '20px', padding: '8px 22px', borderRadius: '10px' }}>
          <Link
            target='_blank'
            href={process.env.NEXT_PUBLIC_CLIENT_URL + '/choose-monitored-device'}
            style={{ background: '#07273D', color: '#fff', padding: '7px 14px', borderRadius: '10px' }}
          >
            {t('Add an iPhone device')}
          </Link>
        </div>
      </Modal>

      {/* 延长续费 */}

      <Modal open={extendSubscriptionModal} onCancel={() => setExtendSubscriptionModal(false)} footer={[]}>
        <p style={{ marginTop: '10px', fontWeight: '600' }}>
          {t('After confirmation a new order will be produced to extend the equipment expiration time')}
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '14px' }}>
          <Button onClick={() => extendSubscription()} style={{ marginRight: '10px' }}>
            {t('Confirm')}
          </Button>
          <Button onClick={() => setExtendSubscriptionModal(false)}>{t('Cancel')}</Button>
        </div>
      </Modal>
    </div>
  )
}

export default Dashboard1
